
import React from "react";
import { Table } from "@/components/ui/table";
import TableHeader from "./tables/TableHeader";
import StandardTableBody from "./tables/StandardTableBody";
import { isWedgingTest, isBunkerTest, isChippingTest, isPuttingTest } from "../level3/scoring/utils";

interface ScoresState {
  [key: string]: (number | null)[];
}

interface LevelInfo {
  level: string;
}

interface ResultsTableProps {
  selectedTest: string | null;
  scores: ScoresState;
  testPoints: string[];
  getTestDistances: (testId: string) => Record<string, string>;
  getTableHeadTitle: () => string;
  getFormattedPoint: (point: string) => string;
  getPointTotal: (point: string) => number;
  getGrandTotal: () => number;
  levels?: Record<string, string | LevelInfo>;
}

const ResultsTable: React.FC<ResultsTableProps> = ({
  selectedTest,
  scores,
  testPoints,
  getTestDistances,
  getTableHeadTitle,
  getFormattedPoint,
  getPointTotal,
  getGrandTotal,
  levels = {}
}) => {
  const isWedging = selectedTest ? isWedgingTest(selectedTest) : false;
  const isBunker = selectedTest ? isBunkerTest(selectedTest) : false;
  const isChipping = selectedTest ? isChippingTest(selectedTest) : false;
  const isPutting = selectedTest ? isPuttingTest(selectedTest) : false;
  
  // Vérifier si c'est un test de putts spéciaux (autres que "putts-plat")
  const isSpecialPutts = selectedTest ? (
    selectedTest === "putts-montee" || 
    selectedTest === "putts-descente" || 
    selectedTest === "putts-pente" || 
    selectedTest === "putts-pente-droite"
  ) : false;

  // Ajout de logs pour le débogage
  console.log("ResultsTable - selectedTest:", selectedTest);
  console.log("ResultsTable - testPoints:", testPoints);
  console.log("ResultsTable - scores:", scores);
  console.log("ResultsTable - isSpecialPutts:", isSpecialPutts);

  return (
    <div className="overflow-x-auto mt-6">
      <Table>
        <TableHeader 
          isChippingTest={isChipping}
          isSpecialPutts={isSpecialPutts}
          getTableHeadTitle={getTableHeadTitle}
          isWedgingTest={isWedging}
          isPuttingTest={isPutting}
        />
        
        <StandardTableBody 
          testPoints={testPoints}
          scores={scores}
          isSpecialPutts={isSpecialPutts}
          getPointTotal={getPointTotal}
          getGrandTotal={getGrandTotal}
          getTestDistances={getTestDistances}
          selectedTest={selectedTest}
          levels={levels}
          isWedgingTest={isWedging}
          isBunkerTest={isBunker}
        />
      </Table>
    </div>
  );
};

export default ResultsTable;
